<template>
<div>
  <div style="height:64px"></div>
  <div class="footer">woshuoxia&nbsp;&nbsp;2019 ~ 2024 <a @click="toBeian()" style="color: grey;" href="https://beian.miit.gov.cn/#/Integrated/index" _target="_blank">备案信息：蜀ICP备2020025859号-1</a></div>
</div>
</template>
<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
    methods:{
      toBeian(){
          window.open('https://beian.miit.gov.cn/#/Integrated/index');
      }
    }
}
</script>
<style lang="less" scoped>
@import "../assets/css/index.less";
.footer{
  height:64px;
  line-height: 64px;
  background:#F8F8F8;
  text-align: center;

  .positionFixedB;
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue